import { render, staticRenderFns } from "./CadDocumentos.vue?vue&type=template&id=f1626f28&"
import script from "./CadDocumentos.vue?vue&type=script&lang=js&"
export * from "./CadDocumentos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports